/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Ica } from "./Ica";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const IcasR = t.interface({
  icas: t.readonlyArray(Ica, "array of Ica"),

  page_info: PageInfo
});

// optional attributes
const IcasO = t.partial({});

export const Icas = t.intersection([IcasR, IcasO], "Icas");

export type Icas = t.TypeOf<typeof Icas>;
